import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <polygon points="3,5 8,11 13,5 " />,
  'ArrowTriangleDown',
);
